import { z } from 'zod';

// Avatar data schema for validation
export const avatarSchema = z.object({
  url: z.string().url(),
  gender: z.string().optional(),
  collection: z.string().optional(),
  label: z.string().optional(),
  id: z.string().optional()
});

// Simple array validation - validate entire list at once
export const avatarListSchema = z.array(avatarSchema);

// Type export
export type AvatarData = z.infer<typeof avatarSchema>;